import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from '../config/config';
import { UsuarioLogadoGet } from '../utils/usuarioEstaLogado';
import configSiteUrls from '../features/site/configs/configSiteUrls';
import configUrls from '../config/configUrls';

const baseUrl = `${config.API_URL}`;

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,

  prepareHeaders: (headers, { getState }) => {
    const token = UsuarioLogadoGet();

    if (token.token) {
      headers.set('Authorization', `Bearer ${token.token}`);
    }

    if (token.usuario) {
      headers.set('User', `${token.usuario}`);
    }

    if (token.ip) {
      headers.set('Ip', `${token.ip}`);
    }

    headers.set('Setor', `${token.setorId}`);
    return headers;
  }
});

export const customBaseQuery: typeof baseQuery = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  // Verifica se é um erro 403
  if (result.error?.status === 403) {
    console.warn('Acesso negado! Redirecionando...');

    // Redireciona para página de aviso
    window.location.href = configUrls.FORBIDDEN;
  }

  return result;
};

// Define a service using a base URL and expected endpoints
export const apiSlice = createApi({
  reducerPath: 'api',
  tagTypes: [
    'Login',
    'Grupo',
    'TipoProcesso',
    'Processo',
    'TipoDocumento',
    'Setor',
    'Orgao',
    'Documento',
    'Secretaria',
    'Usuario',
    'Acompanhamento',
    'Bloco',
    'Marcador',
    'ProcessoEnviar',
    'ProcessoSobrestar',
    'ProcessoConcluir',
    'ProcessoPrazo',
    'Email',
    'DocumentoComentario',
    'DocumentoVersao',
    'DocumentoAssinar',
    'MenuPai',
    'MenuFilho',
    'MenuNeto',
    'NoticiaSite',
    'NoticiaAnexoSite',
    'PublicacaoOficial',
    'PublicacaoOficialAnexoSite',
    'Licitacao',
    'LicitacaoAnexoSite',
    'TipoPublicacaoOficial',
    'Vereador',
    'OuvidoriaAnexoSite',
    'Ouvidoria',
    'CentroApoioAnexoSite',
    'CentroApoio',
    'AcessoInformacao',
    'AcessoInformacaoAnexoSite'
  ],
  baseQuery: baseQuery,
  //customBaseQuery,
  //  Desativa o cache assim que os dados não estão mais em uso
  keepUnusedDataFor: 0,
  //  Refaz as queries toda vez que o componente montar
  /*defaultOptions: {
    queries: {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: false,
      refetchOnReconnect: false,
    }
  },
  */

  endpoints: builder => ({})
});
